import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import {
  CheckboxWidget,
  TextWidget,
  DatetimeWidget,
} from '@plone/volto/components';

const messages = defineMessages({
  title: {
    id: 'countDown_title',
    defaultMessage: 'Titolo',
  },
  subtitle: {
    id: 'countDown_subtitle',
    defaultMessage: 'Sottotitolo',
  },
  endDate: {
    id: 'countDown_endDate',
    defaultMessage: 'Scadenza',
  },
  showBg: {
    id: 'countDown_showBg',
    defaultMessage: 'Applica lo sfondo',
  },
  showHours: {
    id: 'countDown_showHours',
    defaultMessage: 'Mostra le ore',
  },
  showMinutes: {
    id: 'countDown_showMinutes',
    defaultMessage: 'Mostra i minuti',
  },
  showSeconds: {
    id: 'countDown_showSeconds',
    defaultMessage: 'Mostra i secondi',
  },
});

const Sidebar = ({ block, data, onChangeBlock, required }) => {
  const intl = useIntl();

  useEffect(() => {
    onChangeBlock(block, {
      ...data,
      showBg: data.showBg === undefined ? true : data.showBg,
      showHours: data.showHours === undefined ? true : data.showHours,
      showMinutes: data.showMinutes === undefined ? true : data.showMinutes,
      showSeconds: data.showSeconds === undefined ? true : data.showSeconds,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage id="count_down_block" defaultMessage="Count down" />
        </h2>
      </header>
      <div className="ui form">
        <TextWidget
          id="title"
          title={intl.formatMessage(messages.title)}
          value={data.title}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
        <TextWidget
          id="subtitle"
          title={intl.formatMessage(messages.subtitle)}
          value={data.subtitle}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />

        <CheckboxWidget
          id="showBg"
          title={intl.formatMessage(messages.showBg)}
          value={data.showBg}
          onChange={(name, checked) => {
            onChangeBlock(block, { ...data, [name]: checked });
          }}
        />
        <DatetimeWidget
          id="endDate"
          title={intl.formatMessage(messages.endDate)}
          value={data.endDate}
          onChange={(name, value) => {
            onChangeBlock(block, { ...data, [name]: value });
          }}
        />
        <CheckboxWidget
          id="showHours"
          title={intl.formatMessage(messages.showHours)}
          value={data.showHours}
          onChange={(name, checked) => {
            onChangeBlock(block, { ...data, [name]: checked });
          }}
        />
        <CheckboxWidget
          id="showMinutes"
          title={intl.formatMessage(messages.showMinutes)}
          value={data.showMinutes}
          onChange={(name, checked) => {
            onChangeBlock(block, { ...data, [name]: checked });
          }}
        />
        <CheckboxWidget
          id="showSeconds"
          title={intl.formatMessage(messages.showSeconds)}
          value={data.showSeconds}
          onChange={(name, checked) => {
            onChangeBlock(block, { ...data, [name]: checked });
          }}
        />
      </div>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  block: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  openObjectBrowser: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

export default Sidebar;
